import { computed, useHost } from "vue";
import { createEventDispatcher } from "@/runtime/shared/events";
import type { InputTagProps } from "./input.types";
import { inputTagClasses, inputTagRemoveButtonClasses } from "./input.styles";

export interface UseInputTagOptions {
  props: Readonly<InputTagProps>;
}

export const useInputTag = (options: UseInputTagOptions) => {
  const { props } = options;
  const host = useHost();
  const dispatchEvent = createEventDispatcher(host);

  const label = computed(() => props.displayValue ?? String(props.value));
  const wrapperClass = computed(() => inputTagClasses({ size: props.size }));
  const removeButtonClass = computed(() => inputTagRemoveButtonClasses({ size: props.size }));

  const handleRemove = (e: Event) => {
    e.stopPropagation();
    e.preventDefault();
    dispatchEvent("remove", props.value);
  };

  return { label, wrapperClass, removeButtonClass, handleRemove };
};
